import { Progress } from 'antd';
import React from 'react';

import Flex from '@ui-pc/Flex';
import Text from '@ui-pc/Text';
import { Knife, Type } from '@utils/tool';

import { ctx } from '../../utils';

export type Distribution = {
  star: string
  reviewNum: string
  proportion: 0.87
  proportionFormat: string
}

export const categoryArr = Knife.newArray(5, () => ({} as Distribution))

export const ReviesPercent = () => {
  const [state, setState] = ctx.useState()
  const ref = ctx.useRef()
  const { reviewsDistribution } = state
  const category = Object.assign(categoryArr, reviewsDistribution)
  return (
    <div className="percent">
      {Knife.map(category, (data, index) => {
        const percent = (data.proportion * 100).toFixed(2)
        return (
          <Flex
            onClick={() => {
              ref.current.onRatingFilter(parseInt(data.star) || 0)
              // setState({ tabsKey: '2' })
            }}
            alignItems="baseline"
            justify="left"
            className="percent-box">
            <span className="percent-lv">{data.star}</span>
            <Progress
              className="percent-pro"
              strokeColor="#9A5037"
              percent={Number(percent)}
              showInfo={false}
            />
            <p className="percent-desc">
              <Text className="percent-num">{data.reviewNum}</Text>
              <Text className="percent-rate">
                (<Text>{data.proportionFormat}</Text>)
              </Text>
            </p>
          </Flex>
        )
      })}
    </div>
  )
}
